import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoggedIn: false,
    token: "",
    refresh_token: "",
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers:{
        login: (state, {payload}) => {
            return{
                ...state,
                token: payload.token,
                refresh_token: payload.refresh_token,
                isLoggedIn: true,
            }
        },
        logout: (state) => {
            return{
                ...state,
                isLoggedIn: false,
                token: "",
                refresh_token: ""
            }
        }
    }
})



export const { login, logout } = authSlice.actions
export default authSlice.reducer